import { useEffect, useState } from "react";
import { FilledButton, OutlinedButton } from "../../common/Button";
import Lightbox from "../../common/Lightbox";
import { ITask } from "../../../data_models/task";

import useArielle from "../../../hooks/useArielle";
import ArielleSpeechBubble from "../../aiAgent/SpeechBubble";
import { EArielleProcessingType } from "../../../data_models/aiModels/enums";
import useConfig from "../../../hooks/useConfig";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { EUserType } from "../../../data_models/enums";
import { EmployerWallet } from "../../../data_models/employerWallet";
import { IEmployer } from "../../../data_models/employer";
import useRouting from "../../../hooks/useRouting";


interface CreateNewRoadmapLightboxProps {
    projectId: string;
    onClose: () => void;
    onReplaceTasks: (newTasks: ITask[]) => void;
}

const CreateNewRoadmapLightbox: React.FC<CreateNewRoadmapLightboxProps> = ({ projectId, onClose, onReplaceTasks }) => {

    const {
        requestProjectRoadmap,
        isProcessing
    } = useArielle();

    const { config } = useConfig();
    const { currentUserType, wallet, currentUser } = useCurrentUser();
    const { goToPricing } = useRouting();

    const [canUseFreeRoadmaps, setCanUseFreeRoadmaps] = useState(false);
    const [canUsePaidRoadmaps, setCanUsePaidRoadmaps] = useState(false);

    const [mustBuyCredits, setMustBuyCredits] = useState(false);
    const [canCreateRoadmap, setCanCreateRoadmap] = useState(false);
    useEffect(() => {
        if (currentUserType === EUserType.EMPLOYER && wallet && config) {
            if (((currentUser as IEmployer)._individualFreeRoadmaps || 0) + config.featureLimits.employer.freeRoadmaps > ((currentUser as IEmployer)._usedFreeRoadmaps || 0)) {
                setCanUseFreeRoadmaps(true);
                setCanCreateRoadmap(true);
            } else if ((wallet as EmployerWallet).totalCredits - (wallet as EmployerWallet).totalOccupiedCredits >= config.prices.aiRoadmap) {
                setCanUsePaidRoadmaps(true);
                setCanCreateRoadmap(true);
            } else {
                setMustBuyCredits(true);
                setCanCreateRoadmap(false);
            }
        }
    }, [currentUserType, wallet, config]);

    const onCreateRoadmap = async () => {
        requestProjectRoadmap(projectId);
        onClose();
    }

    return (
        <Lightbox
            header="Create new Roadmap"
            content={
                <div className="flex flex-col items-start space-y-3" >
                    <p>Arielle, your AI assistant producer, is here to help you create a fresh new roadmap for your project.
                        Just a heads-up — this will replace your current roadmap and start from scratch. Once you continue,
                        the old version can’t be restored.</p>
                    <p>We suggest downloading your current roadmap so you can keep it for reference.</p>

                    {canUsePaidRoadmaps && <p>You’ve used all your free roadmaps. Creating a new one will just cost 1 credit from your wallet. Ready to get started?</p>}
                    {canUseFreeRoadmaps && config && <p>You have {config.featureLimits.employer.freeRoadmaps + ((currentUser as IEmployer)._individualFreeRoadmaps || 0) - ((currentUser as IEmployer)._usedFreeRoadmaps || 0)} free roadmap creations left. Ready to get started?</p>}
                    {mustBuyCredits && <p>You’ve used all your free roadmaps. Creating a new one will just cost 1 credit. Ready to get started?</p>}
                </div>}
            confirmText="Create Roadmap"
            onConfirm={onCreateRoadmap}
            disabledConfirm={!canCreateRoadmap}
            loadingConfirm={isProcessing.has(EArielleProcessingType.CREATE_PROJECT_ROADMAP)}
            onCancel={onClose}
            onClose={onClose}
            onThirdAction={goToPricing}
            thirdActionText="Buy Credits"
        />

    );
}

export default CreateNewRoadmapLightbox;
